import { todayStr } from "../../lib/date";
import { useState, useEffect } from "react";
import StudentAttendanceTab from "../reports/StudentAttendanceTab";
import SnapshotReportTab from "../reports/SnapshotReportTab";
import { AttendanceTrendChart } from "./AttendanceTrendChart";
import { getSemesters } from "../../lib/api";

// Read-only attendance view for a single student's file. Reuses the exact same
// report components (and their fetch functions) from the Reports page, locked to
// this student's id so no attendance logic/queries are rebuilt here.
export function StudentAttendanceReportTab({ student, districts }) {
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    const y = d.getMonth() >= 6 ? d.getFullYear() : d.getFullYear() - 1; // school-year start (Aug)
    return `${y}-08-01`;
  });
  const [endDate, setEndDate] = useState(todayStr());
  const [semesterDates, setSemesterDates] = useState([]);

  useEffect(() => {
    getSemesters().then((r) => setSemesterDates(r.data.semesters || [])).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="student-attendance-report-tab">
      <AttendanceTrendChart studentId={student.id} />
      <StudentAttendanceTab
        students={[student]}
        districts={districts}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        lockedStudentId={student.id}
      />
      <SnapshotReportTab
        students={[student]}
        formerStudents={[]}
        districts={districts}
        semesterDates={semesterDates}
        lockedStudentId={student.id}
      />
    </div>
  );
}
